<script lang="ts">
  import { browser } from "$app/environment"
  import { goto } from "$app/navigation"
  import { appStore } from "$lib/stores/app-store.svelte"

  const { children } = $props()

  const prefix = $derived(appStore.user?.employee.id)

  $effect.pre(() => {
    if (browser && appStore.user != null) {
      goto(`/${prefix || 0}/home`)
    }
  })
</script>

{#if appStore.user == null}
  {@render children()}
{/if}
